import { GameContext } from '../../../contexts/GameContext';
import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import { ZdarGameStepConfiguration } from '../../../configuration/games/zdar-escape-game/zdarEscapeGameContentConfiguration';
import { zdarCustomCiphers } from '../../../configuration/games/zdar-escape-game/zdarEscapeGameCustomCiphers';
import React, { useContext } from 'react';
import ZdarBirdsCipher from './ciphers/ZdarBirdsCipher';
import ZdarButcherCipher from './ciphers/ZdarButcherCipher';
import ZdarConesCipher from './ciphers/ZdarConesCipher';
import ZdarTreesCipher from './ciphers/ZdarTreesCipher';
import parse from 'html-react-parser';

type Props = {
    snow: boolean | null;
};

export default function ZdarCipher({ snow }: Props) {
    const { stepContent } = useContext(GameContext);
    const { cipher, snowCipher } = stepContent as ZdarGameStepConfiguration;

    if (!cipher) {
        return <React.Fragment />;
    }

    const renderedCipher = snow && snowCipher ? snowCipher : cipher;

    const { images, isPathFinder, text, custom, snowImages, snowSelectionText } = renderedCipher;

    const renderLabel = () => {
        if (renderedCipher.label) {
            return <div className="zdar-cipher--label">{renderedCipher.label}</div>;
        } else {
            return <React.Fragment />;
        }
    };

    const renderImage = (i: number, image: any) => {
        return (
            <div key={i} className="cipher-image">
                <ImageWrapper src={image} alt="cipher" shouldScroll={true} allowLightbox={false} />
            </div>
        );
    };
    const renderCipher = () => {
        if (images?.length === 0) {
            return <div />;
        }
        return (
            <div className="cipher-wrapper">
                {renderLabel()}
                {images &&
                    images.map((image, i) => {
                        return renderImage(i, image);
                    })}
            </div>
        );
    };

    const renderText = () => {
        return (
            <div className="zdar-cipher-text-wrapper">
                {renderLabel()}
                <div className="zdar-cipher-text">{text && parse(text)}</div>
            </div>
        );
    };

    const renderCustom = () => {
        if (custom) {
            if (zdarCustomCiphers.cones === custom) {
                return (
                    <div className="zdar-cipher-text-wrapper">
                        {renderLabel()}
                        <ZdarConesCipher />
                    </div>
                );
            }
            if (zdarCustomCiphers.butcher === custom) {
                return (
                    <div className="zdar-cipher-text-wrapper">
                        {renderLabel()}
                        <ZdarButcherCipher />
                    </div>
                );
            }
            if (zdarCustomCiphers.birds === custom) {
                return (
                    <div className="zdar-cipher-image-wrapper">
                        <ZdarBirdsCipher label={renderedCipher.label} />
                    </div>
                );
            }
            if (zdarCustomCiphers.trees === custom) {
                return (
                    <div className="zdar-cipher-image-wrapper">
                        <ZdarTreesCipher label={renderedCipher.label} />
                    </div>
                );
            }
            return null;
        }
        return null;
    };

    const renderPathFinder = () => {
        if (snowImages !== undefined && snow) {
            return (
                <>
                    {renderLabel()}
                    {snowSelectionText !== undefined && (
                        <div className="zdar-cipher-text-wrapper-snow">
                            <div className="zdar-cipher-text">{parse(snowSelectionText)}</div>
                        </div>
                    )}
                    <div className="cipher-wrapper zdar-cipher-pathfinder">
                        {snowImages?.map((image, i) => {
                            return renderImage(i, image);
                        })}
                    </div>
                </>
            );
        }
        return (
            <>
                {renderLabel()}
                {snowSelectionText !== undefined && (
                    <div className="zdar-cipher-text-wrapper-snow">
                        <div className="zdar-cipher-text">{parse(snowSelectionText)}</div>
                    </div>
                )}
                <div className="cipher-wrapper zdar-cipher-pathfinder">
                    {images?.map((image, i) => {
                        return renderImage(i, image);
                    })}
                </div>
            </>
        );
    };

    const renderTextWithImages = () => {
        if (snowImages !== undefined && snow) {
            return (
                <>
                    {snowSelectionText !== undefined && (
                        <div className="zdar-cipher-text-wrapper-snow">
                            <div className="zdar-cipher-text">{parse(snowSelectionText)}</div>
                        </div>
                    )}
                    <div className="cipher-wrapper zdar-cipher-pathfinder zdar-cipher-pathfinder-with-text">
                        {snowImages?.map((image, i) => {
                            return renderImage(i, image);
                        })}
                    </div>
                    <div className="zdar-cipher-text-wrapper">
                        {renderLabel()}
                        <div className="zdar-cipher-text">{text && parse(text)}</div>
                    </div>
                </>
            );
        }
        return (
            <>
                {snowSelectionText !== undefined && (
                    <div className="zdar-cipher-text-wrapper-snow">
                        <div className="zdar-cipher-text">{parse(snowSelectionText)}</div>
                    </div>
                )}
                <div className="cipher-wrapper zdar-cipher-pathfinder zdar-cipher-pathfinder-with-text">
                    {images?.map((image, i) => {
                        return renderImage(i, image);
                    })}
                </div>
                <div className="zdar-cipher-text-wrapper">
                    {renderLabel()}
                    <div className="zdar-cipher-text">{text && parse(text)}</div>
                </div>
            </>
        );
    };
    if (text && images) {
        return renderTextWithImages();
    } else if (isPathFinder) {
        return renderPathFinder();
    } else if (text) {
        return renderText();
    } else if (custom) {
        return renderCustom();
    }

    return renderCipher();
}
